/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, mediaQuery } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : REPORT FILTERS : STYLES --------------- ++++++++++ */
export default theme => ({
	filters: {
		'& .name-filters': {
			marginBottom: pxToEm(30),
			display: 'flex',
			justifyContent: 'flex-start',
			flexWrap: 'wrap',
			'& .dropdown': {
				flex: '1',
				marginRight: pxToEm(10),
				'&:nth-child(1)': {zIndex: '13'},
				'&:nth-child(2)': {zIndex: '12'},
				'&:nth-child(3)': {zIndex: '11'}
			}

		}
	},

	// ((((((((((((((( MEDIA QUERIES ))))))))))))))) //
	[mediaQuery.thinnest]: {
		filters: {
			'& .name-filters': {
				flexDirection: 'column',
				marginBottom: pxToEm(20),
				justifyContent: 'space-around',
				flexWrap: 'wrap',
				'& .dropdown': {
					flex: '1',
					marginBottom: pxToEm(10),
					marginRight: pxToEm(0),
					maxWidth: '100%'
				}
			}
		}
	},
});
